import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bidi-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
